<template>
	<vx-card>
        <div class="flex mb-4">
            <router-link to="/zxcare">
                <feather-icon icon="ChevronLeftIcon" svgClasses="text-primary mr-4"></feather-icon>
            </router-link>
            <strong class="text-primary"><small>{{ $route.query.t ? zisName : 'ZIS' }}</small></strong>
        </div>

        <div class="mb-6" v-if="!$route.query.mt">
            <strong class="block mb-4">
                <small>Pilih Lembaga Penyaluran</small>
            </strong>
            <v-select 
                v-model="mt"
                class="w-full"
                :options="mitra"
            />
        </div>

        <div class="mb-6">
        	<strong class="block mb-4">
        		<small>Pilih Nominal</small>
        	</strong>

        	<v-select
        		v-model="nominal"
        		class="w-full"
        		:options="nominalOptions"
        	/>
        </div>
        <div class="mb-6">
            <div class="flex items-center justify-between">
                <strong class="block">
                    <small>Jumlah</small>
                </strong>
                <!-- <counter @count="count"></counter> -->
            </div>
        </div>
        <div class="mb-6">
        	<strong class="block mb-4">
        		<small>Nama Muzakki Zakat Fitrah</small>
        	</strong>
        	<div v-for="(item, i) in names" :key="i" class="mb-4">
                <vs-input class="w-full" v-model="item.value" />
            </div>
        </div>

        <div class="mb-6">
        	<strong class="block mb-4">
        		<small>Doa Zakat Fitrah</small>
        	</strong>
            <div class="bg-grey p-4">
                <h6 class="text-center mb-5"><strong>{{doaZafit.latin}}</strong></h6>
                <p class="text-center">{{doaZafit.terjemah}}</p>
            </div>
        </div>
        <vs-button
            class="w-full"
            color="primary"
            @click.prevent="payZakat"
            :disabled="nominal === null ? true : false"
        >
            <strong  class="rounded text-white">Lanjutkan Pembayaran</strong>
        </vs-button>

    </vx-card>
</template>
<script>
	import vInputTag from 'vue-input-tag'
	import vSelect from 'vue-select'
	import { doaZafit } from '@/services/zis'
    import Counter from '@/views/components/Counter.vue'

	export default {
		components: {
			vSelect,
			vInputTag,
            Counter
		},
		props: ['category', 'mitra'],
		data: () => ({
            num: 1,
			mt: null,
			user_id: null,
			names: [
                {value: null}
            ],
			doa: null,
			doaZafit,
			type: null,
			nominalOptions: [],
			nominal: null,
			typeFund: null
		}),
		watch: {
			mt(val) {
				if(val != null) {
					this.user_id = val.user ? val.user.id : null
					this.getNominal()
				}
			}
		},
		computed: {
			zisName() {
				return this.$route.query.t.split('_').map(it => this.capitalize(it)).join(' ')
			}
		},
		methods: {
            count(payload) {
                this.num = payload.val
                // this.names = []

                if(payload.ops == '-')  {
                	this.names = this.names.splice(0, this.num)
                }
                else {
                	for(let i = 0; i < this.num;i++) {
	                	if(!this.names[i]) {
	                		this.names.push({
		                        value: null
		                    })
	                	}
	                }
                }
            },
			getSubCategory() {
	            this.$vs.loading()
	            this.$store.dispatch('getZisSubCategory', {
	                kat_id: this.$route.query.ft
	            })
	            .then(subCategory => {
	                this.$vs.loading.close()
	                subCategory.map(item => {
	                    item.label = item.name
	                })
	                this.typeFund = subCategory.length > 0 ? subCategory[0] : 1
	            })
	            .catch(e => {
	                this.$vs.loading.close()
	                this.showError(e)

	                return false
	            })
	        },
			payZakat() {
				if(!this.$route.query.mt) {
	                if(this.mt === null) {
	                    this.$vs.notify({
	                        title: 'Harap pilih lembaga penyaluran',
	                        text: '',
	                        color: 'warning',
	                        position: 'top-right'
	                    })

	                    return false
	                }
	            }

	            if( this.nominal === null ) {
	            	this.$vs.notify({
                        title: 'Harap pilih nominal zakat fitrah',
                        text: '',
                        color: 'warning',
                        position: 'top-right'
                    })

                    return false
	            }

	            if( this.names.find(it => it.value == null || it.value == '') ) {
	            	this.$vs.notify({
                        title: 'Harap isi semua nama muzakki',
                        text: '',
                        color: 'warning',
                        position: 'top-right'
                    })

                    return false
	            }

	            let jumlah_bayar = this.names.length > 0 ? (this.nominal.nominal * this.names.length) : this.nominal.nominal
	            const name = this.names ? this.names.map(it => it.value).join(', ') : ''

	            let payload = {}

	            if( this.$route.query.mt ) {
                    payload = {
                        id: this.typeFund.id,
                        name: `Zakat Fitrah`,
                        jumlah_bayar,
                        names: name,
                        mt: this.$route.query.mt
                    } 
                }
                else {
                    payload = {
                        id: this.typeFund.id,
                        name: `Zakat Fitrah`,
                        jumlah_bayar,
                        names: name,
                        mt: this.mt.user.id
                    }
                }

                this.$vs.loading()
                this.$store.dispatch(`${this.type}/setTransactionProduct`, payload)
                .then(() => {
                	this.$vs.loading.close()
					let nextLink = `/bayar-zis/choose-payment?amount=${jumlah_bayar}&ft=${this.$route.query.ft}&t=${this.type}`;
					nextLink += this.$route.query.mt ? `&mt=${this.$route.query.mt}` : '';
					nextLink += this.$route.query.ref ? `&ref=${this.$route.query.ref}` : '';
                    
					this.$router.push(nextLink);
                })
                .catch(e => {
                	console.error(e)
                	this.$vs.loading.close()
                	this.showError(e)

                	return false
                })
			},
			getNominal() {
				this.nominalOptions = []
				this.$vs.loading()
				this.$store.dispatch('zakat/getNominalZafit', {
					user_id: this.user_id
				})
				.then(nominal => {
					this.$vs.loading.close()
					nominal.sort((a, b) => a.nominal - b.nominal)

					this.nominalOptions = nominal
				})
				.catch(e => {
					console.error(e)
					this.$vs.loading.close()
					this.showError(e)

					return false
				})
			}
		},
		created() {
			this.getSubCategory()
        	this.type = this.$route.query.t ? this.$route.query.t : 'zakat'

        	if(this.$route.query.mt) {
        		this.user_id = this.$route.query.mt
        		this.mt = this.$route.query.mt
        		this.getNominal()
        	}
		}
	}
</script>